import { bffRequestV3, createMittBffClientV3 } from '@/app/bffClient';
import { isProductionEnvironment } from '@/helpers/utils';
import {
  getDeviceById as getDeviceV3,
  getDevices as getDevicesV3,
  setDeviceTemperatureById,
} from 'bff-api/mitt-malarenergi/v3';

export type DeviceInfo = {
  id: string;
  address: string;
  href: string;
};

export type DeviceValues = {
  desiredTemp: number | null;
  nightReductionEnabled: boolean;
  holidayScheduleEnabled: boolean;
  tempIn: number;
  tempOut: number;
  radiatorTemp: number;
  desiredHolidayTemp: number;
  pressure: number;
  flowTemp: number;
  returnTemp: number;
  flow: number;
  hotWaterTemp: number;
  power: number;
};

export type DeviceLink = {
  relation: string;
  href: string;
};

export type DeviceDetails = {
  id: string;
  address: string;
  href: string;
  values: DeviceValues;
  alarms: number[];
  links: DeviceLink[];
  took: number;
};

export const TEMPERATURE_ERROR_CODE = 192; // Specific error code indicating a failed temperature reading, based on observed data.

export const updateDesiredTemperature = (
  newTemperature: number,
  deviceId: string,
  customerId: number,
) => {
  if (!isProductionEnvironment()) {
    return new Promise<{ data: string; status: number }>((resolve) => {
      setTimeout(() => {
        resolve({
          data: newTemperature.toString(),
          status: 200,
        });
      }, 1000);
    });
  }

  return bffRequestV3((client) =>
    setDeviceTemperatureById({
      client,
      path: { customerId, deviceId },
      body: { desiredTemperature: newTemperature },
      throwOnError: true,
    }),
  );
};

export const getDevices = async (customerId: number) => {
  const client = await createMittBffClientV3();
  const result = await getDevicesV3({
    client,
    path: { customerId },
    throwOnError: true,
  });
  return result as unknown as { data: { data: { items: DeviceInfo[] }[] } };
};

export const getDevice = async (customerId: number, deviceId: string) => {
  const client = await createMittBffClientV3();
  const result = await getDeviceV3({
    client,
    path: { customerId, deviceId },
    throwOnError: true,
  });
  return result as unknown as { data: { data: DeviceDetails[] } };
};
